export type ResourceType =
  | "activity"
  | "assignee"
  | "attachment_added"
  | "attachment"
  | "comment_added"
  | "created"
  | "design type"
  | "status"
  | "story";
export type ChatType =
  | `App\\Models\\Attachment-attachment-attachment_added`
  | `App\\Models\\Attachment-story-comment_added`
  | `App\\Models\\Request-activity-assignee`
  | `App\\Models\\Request-activity-brand`
  | `App\\Models\\Request-activity-created`
  | `App\\Models\\Request-activity-design type`
  | `App\\Models\\Request-activity-due_on`
  | `App\\Models\\Request-activity-markup_comment_added`
  | `App\\Models\\Request-activity-name`
  | `App\\Models\\Request-activity-status`
  | `App\\Models\\Request-attachment_added-attachment`
  | `App\\Models\\Request-attachment-attachment_added`
  | `App\\Models\\Request-comment_added-story`;

export interface ChatAttachment {
  attachmentId: number;
  category: string;
  displayName: string;
  id: number;
  name: string;
  path: string;
  url: string;
  version: null | number;
}

export interface ChatUser {
  id: null | number;
  name: null | string;
  profilePhotoPath: null | string;
  roleName: null | string;
  utcOffset: null | string;
}

export interface ChatStory {
  asanaResourceSubtype: null | ResourceType;
  asanaResourceType: null | ResourceType;
  attachment?: ChatAttachment;
  attachmentId: null | number;
  attachments?: ChatAttachment;
  batchId: null | string;
  chatType: ChatType;
  coEditors: null | string;
  comment: null | string;
  commentBatchId: null | string;
  coordinates: null | string;
  createdAt: null | string;
  id: number;
  isEdited: boolean;
  isNotified: boolean;
  isResolved: boolean | null;
  name: string;
  newValue: null | string;
  newValueReference: null | string;
  oldValue: null | string;
  oldValueReference: null | string;
  parentId: null | number;
  parentType: null | string;
  taggedUserIds: null | string;
  updatedAt: null | string;
  user: ChatUser;
  userId: null | number;
}

export type GetChatStoriesParams = {
  parentId: number;
};

export type GetChatStoriesResponse = ChatStory[];

export const DISABLE_SHOW_MORE = new Set([
  "brief_text_updated",
  "description_updated",
  "text_for_design_updated",
]);
